<template>
    <div class="flex border-b border-gray-100 hover:shadow px-3 py-1">
        <Modal :show="showUserSelectionModal"
               :on-close-click="closeUserSelection"
               :on-save-click="closeUserSelection"
               modal-title="Vyberte člena">
            <div>
                <div v-for="user in users"
                     @click="() => selectUser(user)"
                     class="my-4 rounded-full py-1 px-2 flex items-center cursor-pointer transition hover:shadow"
                     :class="selectedPerson.id === user.id ? 'bg-gray-100' : ''"
                     v-ripple>
                    <div class="flex w-10 h-10 rounded-full items-center justify-center text-sm text-white"
                         :class="'bg-'+user.color">
                        {{ getInicials(user) }}
                    </div>
                    <div class="ml-4 text-gray-600">
                        {{ user.name }}
                    </div>
                </div>
            </div>
        </Modal>
    
        <Modal :show="showListSelection"
               :on-close-click="closeListSelection"
               :on-save-click="closeListSelection"
               modal-title="Vyberte člena">
            <div>
                <div v-for="g in groups"
                     @click="() => moveTaskTo(g)"
                     class="my-4 rounded-full py-1 px-2 flex items-center cursor-pointer transition hover:shadow  border-b border-gray-100"
                     :class="task.task_group_id === g.id ? 'bg-gray-100' : ''"
                     v-ripple>
                    <div class="pl-4 text-gray-600 w-full">
                        {{ g.name }}
                    </div>
                </div>
            </div>
        </Modal>
    
        <!-- ---------------------------------------------------------------- -->
        
        <span class="w-1/12">
            <checkbox label="" v-model="task.done" @change="() => update(task)"></checkbox>
        </span>
        <span class="text-gray-700 pr-3 w-7/12 pt-1 cursor-text flex">
            <span @dblclick="expandInlineEdit"
                  class="w-full break-all mt-3"
                  :class="task.done ? 'line-through text-gray-400' : ''"
                  v-show="!inlineEdit">{{ task.content }}</span>
            <textarea v-show="inlineEdit"
                      :spellcheck="false"
                      ref="inlineEditField"
                      @focusout="closeInline"
                      class="shadow rounded py-1 px-2 resize-none h-auto overflow-hidden w-full h-full"
                      @keyup="autosizeArea"
                      v-model="task.content"></textarea>
        </span>
        <div class="ml-auto w-4/12 flex items-start pt-3 justify-end">
            <div :class="task.user ? 'bg-gray-200 px-2' : ''"
                 class="ml-auto flex items-center justify-center rounded-full px-1 py-1 hover:shadow cursor-pointer overflow-hidden"
                 v-ripple>
                <div class="flex items-center text-xs text-gray-600" @click="openUserSelection">
                    <span
                        class="w-6 h-6 text-xs rounded-full bg-gray-300 flex items-center justify-center text-white mr-2" :class="task.user ? 'bg-'+task.user.color : ''">
                        <span v-if="task.user">{{ getInicials(task.user) }}</span>
                        <i v-else class="material-icons text-lg">person</i>
                    </span>
                    <span v-if="!task.user">Nepriradené</span>
                    <span v-else>{{ shortifyName(task.user.name) }}</span>
                </div>
                <span v-if="task.user"
                      @click="removeUser"
                      class="flex w-4 h-4 rounded-full bg-gray-400 text-gray-200 flex items-center justify-center"
                      :class="{'ml-2': task.user }"><i class="text-xs material-icons">close</i></span>
                
            </div>
            <div class="relative" v-click-outside="hideDropdown">
                <span class="ml-2 flex items-center justify-center w-8 h-8 rounded-full cursor-pointer hover:shadow"
                      v-ripple @click="() => this.dropdownExpanded = !this.dropdownExpanded">
                    <i class="material-icons">more_vert</i>
                </span>
                <ul class="bg-white absolute top-0 transition text-sm bg-white shadow-md rounded text-black"
                    :style="{'right': '100%'}"
                    :class="{'opacity-100 visible': dropdownExpanded, 'opacity-0 invisible': !dropdownExpanded}">
                    <li>
                        <button class="flex items-center hover:text-orange-500 py-3 pr-6 pl-4" @click="moveTask">
                            <font-awesome class="mr-3" icon="reply"></font-awesome>
                            Presunúť
                        </button>
                    </li>
                    <li>
                        <button class="flex items-center hover:text-orange-500 py-3 pr-6 pl-4" @click="() => onDelete(task)">
                            <font-awesome class="mr-3" :icon="['far', 'trash-alt']"></font-awesome>
                            Zmazať
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import Checkbox from "../../../components/Checkbox";
    import {getInicials, shortifyName} from "../../../utils";
    import {mapState} from "vuex";
    
    export default {
        name: "TaskItem",
        components: {
            Checkbox
        },
        props: {
            task: {
                type: Object,
                required: true
            },
            update: {
                type: Function,
                required: true
            },
            onDelete: {
                type: Function,
                required: true
            },
            move: {
                type: Function,
                required: true,
            }
        },
        
        data: () => ({
            inlineEdit: false,
            defaultTask: {},
            
            selectedPerson: {},
            showUserSelectionModal: false,
            
            showListSelection: false,

            dropdownExpanded: false
        }),
        
        computed: {
            ...mapState({
                users: state => state.users.all,
                groups: state => state.tasks.all
            })
        },

        created() {
            this.defaultTask = Object.assign({}, this.task);
        },
        
        methods: {
            getInicials(u) {
                return getInicials(u.name, u.image);
            },
            
            shortifyName(n) {
                return shortifyName(n);
            },
            
            expandInlineEdit(e) {
                this.inlineEdit = true;
                this.autosizeArea(true);
            },
            
            closeInline() {
                if(!this.inlineEdit)
                    return;
                
                this.inlineEdit = false;
                
                if(JSON.stringify(this.task) === JSON.stringify(this.defaultTask))
                    return;
                
                this.update(this.task);
            },
            
            removeUser() {
                let task = Object.assign({}, this.task);
                task.user = null;
                this.update(task);
            },
            
            // modal window
            openUserSelection() {
                this.showUserSelectionModal = true;
                if(this.task.user) {
                    this.selectedPerson = this.task.user;
                }
            },

            closeUserSelection() {
                this.showUserSelectionModal = false;
                this.selectedPerson = {};
            },
            selectUser(user) {
                this.selectedPerson = user;
                let task = Object.assign({}, this.task);
                task.user = user;
                this.update(task);

                this.closeUserSelection();
            },
            
            // dropdown
            hideDropdown() {
                this.dropdownExpanded = false;
            },
            
            
            // autosize
            autosizeArea(autofocus = false) {
                setTimeout(() => {
                    if(autofocus) {
                        this.$refs.inlineEditField.focus();
                    }
                    
                    this.$refs.inlineEditField.style.height = 50+"px";
                    let h = this.$refs.inlineEditField.scrollHeight;

                    setTimeout(() => this.$refs.inlineEditField.style.height = (h)+"px")
                })
            },

            /// moving
            moveTask() {
                this.showListSelection = true;
            },
            closeListSelection() {
                this.showListSelection = false;
            },
            moveTaskTo(group) {
                this.task.task_group_id = group.id;
                
                this.move(this.task);
                this.closeListSelection();
            }
        }
    }
</script>